import { ogImageMeta } from "@/lib/og-images";
import { createFileRoute } from "@tanstack/react-router";
import { fetchNewestGems } from "@/lib/library-hubs.functions";
import {
  LibraryHubPage,
  itemListJsonLd,
  breadcrumbJsonLd,
} from "@/components/library-hub";

const TITLE = "New this week — freshly curated tools | The Vibeary";
const DESC =
  "The newest additions to The Vibeary: tools, components, shaders and AI skills read and curated daily, newest first.";
const URL = "https://vibing.inc/library/new";

export const Route = createFileRoute("/library/new")({
  loader: async () => {
    try {
      return { gems: await fetchNewestGems() };
    } catch {
      return { gems: [] };
    }
  },
  head: ({ loaderData }) => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      ...ogImageMeta("library-new", "Share card: newest gems in the library"),
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: itemListJsonLd("New this week", URL, loaderData?.gems ?? []),
      },
      {
        type: "application/ld+json",
        children: breadcrumbJsonLd([
          { name: "Home", item: "https://vibing.inc/" },
          { name: "The Vibeary", item: "https://vibing.inc/library" },
          { name: "New this week", item: URL },
        ]),
      },
    ],
  }),
  component: NewHub,
});

function NewHub() {
  const { gems } = Route.useLoaderData();
  return (
    <LibraryHubPage
      eyebrow="The Vibeary — fresh drops"
      title="New this week"
      intro="Everything added to the shelf most recently, newest first. The library grows every day — each entry is opened, checked and written up by hand before it lands here."
      gems={gems}
      crumbs={[
        { label: "Home", to: "/" },
        { label: "The Vibeary", to: "/library" },
        { label: "New this week" },
      ]}
    />
  );
}
